<template>
  <TimeslotDashboardLayout>
    <div class="main-content booking">
      <div>
        <div class="content-div">
          <div class="tap-heading-div">
            <h1 class="tab-heading">Subscriptions</h1>
            <div class="tab-text">
              <div class="text-block-37">
                You can subscribe to a professional’s weekly/monthly plan. All
                subscription booking times are based on your selected time zone
                <span class="text-span-2"
                  ><strong>{{ customerInfo.customerTimezone }}</strong
                  >. </span
                >To update
                <span class="link-6 click-margin" @click="openTime"
                  ><strong>Click Here</strong></span
                >
              </div>
            </div>
            <div
              data-w-id="8274d422-67e8-f9a6-ea31-9d3797cc8d20"
              class="timeslot-button new-booking w-button"
              @click="openNew"
            >
              Subscribe
            </div>
            <div class="no-update_wrapper" v-if="subscriptions.length === 0">
              <div class="no-update_content">
                <img
                  src="@/assets/timeslot-images/timer.svg"
                  loading="lazy"
                  alt=""
                  width="50"
                  height="50"
                />
                <div class="no-update-yet">Nothing to show here</div>
                <div class="appointments">
                  Subscriptions by clients would show up here
                </div>
                <!--              <a href="#" class="explore-professionals_button w-button">Explore professionals</a>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-current="Tab 1"
        data-easing="ease"
        data-duration-in="300"
        data-duration-out="100"
        class="tabs w-tabs"
        v-if="subscriptions.length !== 0"
      >
        <div class="tabs-menu-2 w-tab-menu">
          <a
            data-w-tab="Tab 2"
            :class="
              pending
                ? 'booking-tab w-inline-block w-tab-link w--current'
                : 'booking-tab w-inline-block w-tab-link'
            "
            @click="openPending"
          >
            <div>Pending</div>
          </a>
          <a
            data-w-tab="Tab 3"
            :class="
              active
                ? 'booking-tab w-inline-block w-tab-link w--current'
                : 'booking-tab w-inline-block w-tab-link'
            "
            @click="openActive"
          >
            <div>Active</div>
          </a>
          <a
            data-w-tab="Tab 4"
            :class="
              expired
                ? 'booking-tab w-inline-block w-tab-link w--current'
                : 'booking-tab w-inline-block w-tab-link'
            "
            @click="openExpired"
          >
            <div>Expired</div>
          </a>
        </div>
        <div class="w-tab-content">
          <div
            data-w-tab="Tab 2"
            v-if="pending"
            :class="pending ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
          >
            <div
              class="no-update_wrapper"
              v-if="pendingSubscriptions.length === 0"
            >
              <div class="no-update_content">
                <img
                  src="@/assets/timeslot-images/subscribe.svg"
                  loading="lazy"
                  alt=""
                  width="50"
                  height="50"
                />
                <div class="no-update-yet">
                  <strong>Nothing to show here</strong>
                </div>
                <div class="appointments">
                  <strong>No pending subscriptions</strong>
                </div>
                <!--                <router-link-->
                <!--                    to="/discover-professionals"-->
                <!--                    class="explore-professionals_button w-button"-->
                <!--                >Explore professionals</router-link-->
                <!--                >-->
              </div>
            </div>
            <div v-else>
              <div
                class="bookings-list-wrapper bookings pending"
                v-for="(subscription, index) in pendingSubscriptions"
                :key="index"
              >
                <div class="div-block-24">
                  <div class="text-block-24">
                    Subscribed to
                    <router-link
                      :to="
                        `/professionals/${subscription.subscriptionProfessionalId}`
                      "
                      class="link-5"
                      >{{ subscription.professionalName }}</router-link
                    >
                  </div>
                  <div class="div-block-22">
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-7"
                      />
                      <div>
                        {{ subscription.subscriptionType }} ({{
                          shortDays(subscription.subscriptionDayString)
                        }})
                      </div>
                    </div>
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-8"
                      />
                      <div>
                        {{ subscription.subscriptionStartTime.slice(0, 5)
                        }}{{ amPm(subscription.subscriptionStartTime) }}
                        -
                        {{ subscription.subscriptionEndTime.slice(0, 5)
                        }}{{ amPm(subscription.subscriptionEndTime) }} ({{
                          customerInfo.customerTimezone
                        }})
                      </div>
                    </div>
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-9"
                      />
                      <div>{{ subscription.subscriptionAmount }} USD</div>
                    </div>
                  </div>
                </div>
                <div
                  class="div-block-25"
                  v-if="details && activeIndex === index"
                >
                  <div class="professional-detail-wrapper">
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Professional:</div>
                      <div class="div-block-26">
                        <div>
                          <img
                            loading="lazy"
                            width="45"
                            :src="
                              subscription.professionalProfilePicture ||
                                require('@/assets/timeslot-images/profileImg.svg')
                            "
                            alt=""
                            class="image-10"
                          />
                        </div>
                        <div>
                          <div class="text-block-26">
                            {{ subscription.professionalName }}
                          </div>
                          <div>{{ subscription.professionalSubCategory }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Professional’s TimeZone</div>
                      <div class="div-block-26">
                        <div>
                          <div class="text-block-26">
                            {{ subscription.professionalTimezone }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Topic</div>
                      <div class="div-block-26">
                        <div>
                          <div class="text-block-26">
                            {{ subscription.subscriptionTopic }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Your Message</div>
                      <div class="div-block-26">
                        <div>
                          <p class="paragraph-2">
                            {{ subscription.subscriptionMessage }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="div-block-27">
                  <div
                    data-w-id="603342f9-e3a3-15c8-f460-f993fae02cdd"
                    href=""
                    class="button-4 hide w-button"
                    @click="closeDetails(index)"
                    v-if="details && activeIndex === index"
                  >
                    Hide details
                  </div>
                  <div
                    data-w-id="603342f9-e3a3-15c8-f460-f993fae02cdd"
                    href=""
                    class="button-4 hide w-button"
                    @click="openDetails(index)"
                    v-if="!details || activeIndex !== index"
                  >
                    View details
                  </div>
                  <!--                  <div-->
                  <!--                    data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e9"-->
                  <!--                    href=""-->
                  <!--                    class="button-4-copy outline w-button"-->
                  <!--                  >-->
                  <!--                    Cancel-->
                  <!--                  </div>-->
                </div>

                <div class="div-block-27-copy pending">
                  <div
                    class="text-block-101"
                    v-if="!details || activeIndex !== index"
                  >
                    Pending
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-w-tab="Tab 3"
            v-if="active"
            :class="active ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
          >
            <div
              class="no-update_wrapper"
              v-if="activeSubscriptions.length === 0"
            >
              <div class="no-update_content">
                <img
                  src="@/assets/timeslot-images/subscribe.svg"
                  loading="lazy"
                  alt=""
                  width="50"
                  height="50"
                />
                <div class="no-update-yet">
                  <strong>Nothing to show here</strong>
                </div>
                <div class="appointments">
                  <strong>No active subscriptions</strong>
                </div>
                <!--                <router-link-->
                <!--                    to="/discover-professionals"-->
                <!--                    class="explore-professionals_button w-button"-->
                <!--                >Explore professionals</router-link-->
                <!--                >-->
              </div>
            </div>
            <div v-else>
              <div
                class="bookings-list-wrapper bookings pending"
                v-for="(subscription, index) in activeSubscriptions"
                :key="index"
              >
                <div class="div-block-24">
                  <div class="text-block-24">
                    Subscribed to
                    <router-link
                      :to="
                        `/professionals/${subscription.subscriptionProfessionalId}`
                      "
                      class="link-5"
                      >{{ subscription.professionalName }}</router-link
                    >
                  </div>
                  <div class="div-block-22">
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-7"
                      />
                      <div>
                        {{ subscription.subscriptionType }} ({{
                          shortDays(subscription.subscriptionDayString)
                        }})
                      </div>
                    </div>
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-8"
                      />
                      <div>
                        {{ subscription.subscriptionStartTime.slice(0, 5)
                        }}{{ amPm(subscription.subscriptionStartTime) }}
                        -
                        {{ subscription.subscriptionEndTime.slice(0, 5)
                        }}{{ amPm(subscription.subscriptionEndTime) }} ({{
                          customerInfo.customerTimezone
                        }})
                      </div>
                    </div>
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-9"
                      />
                      <div>{{ subscription.subscriptionAmount }} USD</div>
                    </div>
                  </div>
                </div>
                <div
                  class="div-block-25"
                  v-if="details && activeIndex === index"
                >
                  <div class="professional-detail-wrapper">
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Professional:</div>
                      <div class="div-block-26">
                        <div>
                          <img
                            loading="lazy"
                            width="45"
                            :src="
                              subscription.professionalProfilePicture ||
                                require('@/assets/timeslot-images/profileImg.svg')
                            "
                            alt=""
                            class="image-10"
                          />
                        </div>
                        <div>
                          <div class="text-block-26">
                            {{ subscription.professionalName }}
                          </div>
                          <div>{{ subscription.professionalSubCategory }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Professional’s TimeZone</div>
                      <div class="div-block-26">
                        <div>
                          <div class="text-block-26">
                            {{ subscription.professionalTimezone }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Topic</div>
                      <div class="div-block-26">
                        <div>
                          <div class="text-block-26">
                            {{ subscription.subscriptionTopic }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Your Message</div>
                      <div class="div-block-26">
                        <div>
                          <p class="paragraph-2">
                            {{ subscription.subscriptionMessage }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="div-block-27">
                  <div
                    data-w-id="603342f9-e3a3-15c8-f460-f993fae02cdd"
                    class="button-4 hide w-button"
                    @click="closeDetails(index)"
                    v-if="details && activeIndex === index"
                  >
                    Hide details
                  </div>
                  <div
                    data-w-id="603342f9-e3a3-15c8-f460-f993fae02cdd"
                    class="button-4 hide w-button"
                    @click="openDetails(index)"
                    v-if="!details || activeIndex !== index"
                  >
                    View details
                  </div>
                  <!--                  <div-->
                  <!--                    data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e9"-->
                  <!--                    href=""-->
                  <!--                    class="button-4-copy outline w-button"-->
                  <!--                  >-->
                  <!--                    Cancel-->
                  <!--                  </div>-->
                </div>
                <div class="div-block-27-copy pending">
                  <div class="active" v-if="!details || activeIndex !== index">
                    Active
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-w-tab="Tab 4"
            v-if="expired"
            :class="expired ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
          >
            <div
              class="no-update_wrapper"
              v-if="expiredSubscriptions.length === 0"
            >
              <div class="no-update_content">
                <img
                  src="@/assets/timeslot-images/subscribe.svg"
                  loading="lazy"
                  alt=""
                  width="50"
                  height="50"
                />
                <div class="no-update-yet">
                  <strong>Nothing to show here</strong>
                </div>
                <div class="appointments">
                  <strong>No expired subscriptions</strong>
                </div>
                <!--                <router-link-->
                <!--                    to="/discover-professionals"-->
                <!--                    class="explore-professionals_button w-button"-->
                <!--                >Explore professionals</router-link-->
                <!--                >-->
              </div>
            </div>
            <div v-else>
              <div
                class="bookings-list-wrapper bookings pending"
                v-for="(subscription, index) in expiredSubscriptions"
                :key="index"
              >
                <div class="div-block-24">
                  <div class="text-block-24">
                    Subscribed to
                    <router-link
                      :to="
                        `/professionals/${subscription.subscriptionProfessionalId}`
                      "
                      class="link-5"
                      >{{ subscription.professionalName }}</router-link
                    >
                  </div>
                  <div class="div-block-22">
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-7"
                      />
                      <div>
                        {{ subscription.subscriptionType }} ({{
                          shortDays(subscription.subscriptionDayString)
                        }})
                      </div>
                    </div>
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-8"
                      />
                      <div>
                        {{ subscription.subscriptionStartTime.slice(0, 5)
                        }}{{ amPm(subscription.subscriptionStartTime) }}
                        -
                        {{ subscription.subscriptionEndTime.slice(0, 5)
                        }}{{ amPm(subscription.subscriptionEndTime) }} ({{
                          customerInfo.customerTimezone
                        }})
                      </div>
                    </div>
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-9"
                      />
                      <div>{{ subscription.subscriptionAmount }} USD</div>
                    </div>
                  </div>
                </div>
                <div
                  class="div-block-25"
                  v-if="details && activeIndex === index"
                >
                  <div class="professional-detail-wrapper">
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Professional:</div>
                      <div class="div-block-26">
                        <div>
                          <img
                            loading="lazy"
                            width="45"
                            :src="
                              subscription.professionalProfilePicture ||
                                require('@/assets/timeslot-images/profileImg.svg')
                            "
                            alt=""
                            class="image-10"
                          />
                        </div>
                        <div>
                          <div class="text-block-26">
                            {{ subscription.professionalName }}
                          </div>
                          <div>{{ subscription.professionalSubCategory }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Professional’s TimeZone</div>
                      <div class="div-block-26">
                        <div>
                          <div class="text-block-26">
                            {{ subscription.professionalTimezone }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Topic</div>
                      <div class="div-block-26">
                        <div>
                          <div class="text-block-26">
                            {{ subscription.subscriptionTopic }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Your Message</div>
                      <div class="div-block-26">
                        <div>
                          <p class="paragraph-2">
                            {{ subscription.subscriptionMessage }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="div-block-27">
                  <div
                    data-w-id="603342f9-e3a3-15c8-f460-f993fae02cdd"
                    class="button-4 hide w-button"
                    @click="closeDetails(index)"
                    v-if="details && activeIndex === index"
                  >
                    Hide details
                  </div>
                  <div
                    data-w-id="603342f9-e3a3-15c8-f460-f993fae02cdd"
                    class="button-4 hide w-button"
                    @click="openDetails(index)"
                    v-if="!details || activeIndex !== index"
                  >
                    View details
                  </div>
                  <!--                  <div-->
                  <!--                    data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e9"-->
                  <!--                    class="button-4-copy outline w-button"-->
                  <!--                  >-->
                  <!--                    Cancel-->
                  <!--                  </div>-->
                </div>
                <div class="div-block-27-copy pending">
                  <div class="expired" v-if="!details || activeIndex !== index">
                    Expired
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NewBookingModal v-if="book" :cancel="closeNew" />
    <UpdateTimezoneModal v-if="time" :cancel="closeTime" />
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
import NewBookingModal from "@/components/modal/NewBookingModal";
import UpdateTimezoneModal from "@/components/modal/UpdateTimezoneModal";
import { mapState } from "vuex";
import moment from "moment/moment";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import SubscriptionRequest from "@/model/requests/SubscriptionRequest";
import CustomerRequest from "@/model/requests/CustomerRequest";
export default {
  name: "CustomerSubscriptions",
  data() {
    return {
      time: false,
      pending: true,
      active: false,
      expired: false,
      details: false,
      bar: true,
      cross: false,
      book: false,
      readModel: SubscriptionRequest.readByCustomerId,
      readCusModel: CustomerRequest.readBy,
      activeIndex: null
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      customerInfo: state => state.customer.customerInfo,
      subscriptions: state => state.subscription.customerSubscriptions
    }),
    pendingSubscriptions() {
      return this.subscriptions.filter(
        item => item.subscriptionStatus === "PENDING"
      );
    },
    activeSubscriptions() {
      return this.subscriptions.filter(
        item => item.subscriptionStatus === "ACTIVE"
      );
    },
    expiredSubscriptions() {
      return this.subscriptions.filter(
        item => item.subscriptionStatus === "EXPIRED"
      );
    }
  },
  components: { TimeslotDashboardLayout, NewBookingModal, UpdateTimezoneModal },
  methods: {
    toggleDetails() {
      this.details = !this.details;
    },
    openDetails(index) {
      this.activeIndex = index;
      this.details = true;
    },
    closeDetails(index) {
      this.activeIndex = index;
      this.details = false;
    },
    openTime() {
      this.time = true;
    },
    closeTime() {
      this.time = false;
    },
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    },
    openPending() {
      this.pending = true;
      this.active = false;
      this.expired = false;
    },
    openActive() {
      this.pending = false;
      this.active = true;
      this.expired = false;
    },
    openExpired() {
      this.pending = false;
      this.active = false;
      this.expired = true;
    },
    formattedDate(date) {
      return moment(date).format("LT");
    },
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatTime(date) {
      return moment(date).format("a");
    },
    formatMinutes(date) {
      return moment(date).format("mm");
    },
    formatHours(date) {
      return moment(date).format("h");
    },
    openNew() {
      this.book = true;
    },
    closeNew() {
      this.book = false;
    },
    shortTimezone(value) {
      let timeStrings = value.split(" ");
      let newList = timeStrings.map(item => item[0]).join("");
      return newList;
    },
    amPm(value) {
      let timeValue = parseInt(value.slice(0, 2));
      if (timeValue >= 12) {
        return "pm";
      } else {
        return "am";
      }
    },
    shortDays(value) {
      let timeStrings = value.split(",");
      let newList = timeStrings.map(item => item.slice(0, 3));
      let days = newList
        .map(element => {
          return (
            element.charAt(0).toUpperCase() + element.slice(1).toLowerCase()
          );
        })
        .join(",");
      return days;
    }
  },
  mounted() {
    this.readModel.subscriptionCustomerId = this.userInfo.customerId;
    StoreUtils.dispatch("subscription/readByCustomerId", this.readModel);

    this.readCusModel.customerId = this.userInfo.customerId;
    StoreUtils.dispatch("customer/readByCustomerId", this.readCusModel);
  }
};
</script>

<style scoped></style>
